import { useApi } from '@backstage/core-plugin-api';
import { SidebarItem } from '@backstage/core-components';
import SecurityIcon from '@material-ui/icons/Security';
import {
  useEffect,
  useState,
  type PropsWithChildren,
  type ReactElement,
} from 'react';
import { dpsApiRef } from '../api/dpsApiRef';
import { Box, Typography } from '@material-ui/core';

export function DpsSidebarItem() {
  const api = useApi(dpsApiRef);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    api
      .checkAccess()
      .then(setVisible)
      .catch(() => setVisible(false));
  }, [api]);

  if (!visible) return null;
  return <SidebarItem icon={SecurityIcon} to="dps" text="DPS" />;
}

export function DpsAccessGuard({
  children,
}: PropsWithChildren<{}>): ReactElement | null {
  const api = useApi(dpsApiRef);
  const [state, setState] = useState<'loading' | 'granted' | 'denied'>(
    'loading',
  );

  useEffect(() => {
    api
      .checkAccess()
      .then(ok => setState(ok ? 'granted' : 'denied'))
      .catch(() => setState('denied'));
  }, [api]);

  if (state === 'loading') return null;

  if (state === 'denied') {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <Typography variant="h6" color="textSecondary">
          You do not have access to DPS. Contact the Data Platform team for
          access.
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
}
